
import patterns from '../patterns.json';
import { __ } from '@wordpress/i18n';
import { parse } from '@wordpress/blocks';

const Patterns = ({ clientId, premiumProps }) => {
    const { setIsProModalOpen, isPremium } = premiumProps;

    return <> {!isPremium && <p className='noticePatter'>{__('Only available on pro version', 'slider')}</p>}
        {patterns.map((pattern, index) => {
            const imgName = pattern.name.replace('/', '-');
            // eslint-disable-next-line no-undef
            const imgPath = bsbInfo.patternsImagePath + imgName + '.png';
            return <div key={index} className='bsbPatters'>
                <img key={index} style={{ width: '100%' }} src={imgPath} />
                <div className="overlyButton">
                    <button onClick={() => {
                        if (isPremium) {
                            const blocks = parse(pattern.content);
                            wp.data.dispatch('core/block-editor').replaceBlock(clientId, blocks);
                        } else {
                            setIsProModalOpen(true);
                        }
                    }}>{__('Apply', 'slider')}</button>
                </div>
            </div>
        })}
    </>
}
export default Patterns;